export enum ActionSearchHistorian {
  Save = 'save',
}
